const getSignedUrl = () => {
  const result = {
    resourceType: null,
    resourceId: null,
    expiration: null,
    signature: null,
    isSignedUrl: false,
  };

  try {
    window.location.search
      .substr(1) // remove '?'
      .split("&") // split key=val pairs
      .forEach(kvp => {
        const parts = kvp.split("=");
        if (parts[0] === "X-APP-SIGNED-RESOURCE-TYPE") result.resourceType = parts[1];
        if (parts[0] === "X-APP-SIGNED-RESOURCE-ID") result.resourceId = parts[1];
        if (parts[0] === "X-APP-SIGNED-EXPIRATION") result.expiration = parts[1];
        if (parts[0] === "X-APP-SIGNED-SIGNATURE") result.signature = parts[1];
      });
  } catch {
    // no op
  }

  result.isSignedUrl = result.resourceType && result.resourceId && result.expiration && result.signature;

  return result;
};

export default {
  // parts
  getResourceType: () => getSignedUrl().resourceType,
  getResourceId: () => getSignedUrl().resourceId,
  getExpiration: () => getSignedUrl().expiration,
  getSignature: () => getSignedUrl().signature,
  // helpers
  isSignedUrl: () => !!getSignedUrl().isSignedUrl,
  getUserId: () => (getSignedUrl().resourceType === "user" ? getSignedUrl().resourceId : null),
  getTestId: () => (getSignedUrl().resourceType === "test" ? getSignedUrl().resourceId : null),
};
